export const setStateAsync = <P, S, K extends keyof S>(
    that: React.Component<P, S>,
    state: ((prevState: Readonly<S>, props: Readonly<P>) => (Pick<S, K> | S | null)) | (Pick<S, K> | S | null)
): Promise<void> => {
    return new Promise((resolve) => {
        that.setState(state, resolve);
    });
}